import INFO from "./user";

export const getPersonStructuredData = () => ({
	"@context": "https://schema.org",
	"@type": "Person",
	"name": INFO.main.name,
	"alternateName": INFO.main.title,
	"description": "Software Engineer and Data Analyst with expertise in React.js, Next.js, Node.js, Express.js, FastAPI, Flask, and MongoDB",
	"url": "https://emmanuelkyeremeh.vercel.app",
	"image": "https://emmanuelkyeremeh.vercel.app/logo.png",
	"email": INFO.main.email,
	"jobTitle": "Software Engineer & Data Analyst",
	"worksFor": {
		"@type": "Organization",
		"name": "Freelance"
	},
	"address": {
		"@type": "PostalAddress",
		"addressLocality": "Accra",
		"addressCountry": "Ghana"
	},
	"sameAs": [
		INFO.socials.github,
		INFO.socials.linkedin,
		INFO.socials.twitter,
		INFO.socials.stackoverflow
	],
	"knowsAbout": [
		"React.js",
		"Next.js", 
		"Node.js",
		"Express.js",
		"FastAPI",
		"Flask",
		"MongoDB",
		"Machine Learning",
		"Data Analysis",
		"Python",
		"JavaScript",
		"Web Development"
	]
});

export const getWebsiteStructuredData = () => ({
	"@context": "https://schema.org",
	"@type": "WebSite",
	"name": "Emmanuel Kyeremeh Portfolio",
	"alternateName": "Emmanuel Kyeremeh - Software Engineer & Data Analyst",
	"url": "https://emmanuelkyeremeh.vercel.app",
	"description": "Personal portfolio of Emmanuel Kyeremeh, a Software Engineer and Data Analyst showcasing projects, skills, and professional experience.",
	"author": {
		"@type": "Person",
		"name": INFO.main.name
	},
	"inLanguage": "en-US",
	"copyrightYear": new Date().getFullYear(),
	"creator": {
		"@type": "Person",
		"name": INFO.main.name
	}
});

export const getProjectsStructuredData = () => {
	const projects = INFO.projects.map(project => ({
		"@type": "CreativeWork",
		"name": project.title,
		"description": project.description,
		"url": project.link,
		"creator": {
			"@type": "Person",
			"name": INFO.main.name
		},
		"dateCreated": "2023-2024",
		"genre": "Web Application"
	}));

	return {
		"@context": "https://schema.org",
		"@type": "ItemList",
		"name": "Emmanuel Kyeremeh's Projects",
		"description": "A collection of web applications and software projects developed by Emmanuel Kyeremeh",
		"itemListElement": projects.map((project, index) => ({
			"@type": "ListItem",
			"position": index + 1,
			"item": project
		}))
	};
};
